import * as React from 'react';
import {BasePureComponent} from './BaseComponent';
import {Trad} from './';
import * as Dati from '../Dati';
import * as DatiRCP from '../DatiRCP';
import * as Glob from '../Globale';
import {CampoGaranzie} from '../components/';

interface IAccordionGaranzieProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON;
    Abilitato: boolean;
    Indice: number;
    OnChangeElement?: (valore: any) => void;
}

export class AccordionGaranzie extends BasePureComponent<IAccordionGaranzieProps> {

    private _Name: string;
    private _Id: string;

    public constructor(props: any) {
        super(props);
    }

    public render() {
        if (this.props.Name == "GaranzieJSON")
            this._Name = this.props.Name;
        else
            this._Name = this.props.Name + ".GaranzieJSON";

        if (this.props.Id == "GaranzieJSON")
            this._Id = this.props.Id;
        else
            this._Id = this.props.Id + ".GaranzieJSON";

        return <div className="card-header">
            <a href={"#kt_accordion_1_item_" + this.props.Indice + "_body"}
               className="card-title collapsed" role="tab"
               id={"kt_accordion_1_item_" + this.props.Indice + "_head"} data-toggle="collapse"
               aria-expanded="false">
                <span className="accordion__item-icon"><i
                    className="fa flaticon-interface-8"></i></span>
                <span className="accordion__item-icon">{Trad.Trad("Garanzie")}</span>
                <span className="kt-accordion__item-mode"></span>
            </a>
            <div className="kt-accordion__itekt-body collapse"
                 id={"kt_accordion_1_item_" + this.props.Indice + "_body"}
                 role="tabpanel"
                 aria-labelledby={"kt_accordion_1_item_" + this.props.Indice + "_head"}
                 data-parent="#kt_accordion_1">
                <CampoGaranzie
                    Name={this._Name}
                    Id={this._Id}
                    Value={this.props.Value}
                    OnChange={this.props.OnChange}
                    Abilitato={this.props.Abilitato}
                    OnChangeElement={this.props.OnChangeElement}
                />
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/AccordionGaranzie.tsx